import React from 'react';
import { Flex, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';

export const EmptyView = ({ hasActiveFilters }) => {
  if (hasActiveFilters) {
    return (
      <Flex width={1} justifyContent="center" p="80px 0" flexDirection="column" data-testid="no-admins-match">
        <Text fontSize="16px" mx="auto" mb="8px" fontWeight="medium">
          No results
        </Text>
        <Text mx="auto" fontSize="14px">
          No team members match your filters.
        </Text>
      </Flex>
    );
  }

  return (
    <Flex width={1} justifyContent="center" mt={5}>
      <Text>There are no team members for the network at this time</Text>
    </Flex>
  );
};

EmptyView.propTypes = {
  hasActiveFilters: PropTypes.bool,
};

EmptyView.defaultProps = {
  hasActiveFilters: false,
};
